var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_12003)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 0H0V100H100V0ZM24.7764 12C18.3514 12.0224 13.0905 17.2432 13.001 23.6738C12.9338 28.8834 16.2583 33.3423 20.9035 34.9779C21.0154 35.0228 21.1274 34.9219 21.1162 34.8099C21.0975 34.6755 21.0776 34.541 21.0577 34.4066C21.0179 34.1377 20.9781 33.8688 20.9483 33.5999C20.9259 33.4543 20.8363 33.3423 20.7132 33.2751C17.0418 31.673 14.4785 27.9871 14.5233 23.7187C14.5793 18.117 19.1461 13.5573 24.7316 13.5125C30.4514 13.4676 35.119 18.1058 35.119 23.8195C35.119 28.0431 32.5669 31.673 28.9291 33.2751C28.7948 33.3311 28.7052 33.4543 28.6941 33.5999L28.5262 34.8099C28.5038 34.9331 28.6269 35.0228 28.7388 34.9779C33.3393 33.3647 36.6413 28.973 36.6413 23.8195C36.6189 17.2992 31.3021 11.9888 24.7764 12ZM24.8084 25.612C26.3307 25.612 27.562 24.3796 27.562 22.8559C27.562 21.3435 26.3307 20.0999 24.8084 20.0999C23.2861 20.0999 22.0548 21.3323 22.0548 22.8559C22.0548 24.3796 23.2861 25.612 24.8084 25.612ZM27.239 27.6065C27.5077 27.8753 27.642 28.1666 27.6868 28.5699C27.7763 29.3542 27.7315 30.0264 27.6308 31.1131C27.5413 32.1438 27.3734 33.5106 27.1607 34.911C27.004 35.9081 26.8809 36.4459 26.7689 36.8268C26.5898 37.4429 25.8958 37.9919 24.8101 37.9919C23.7243 37.9919 23.0415 37.4541 22.8513 36.8268C22.7393 36.4459 22.6162 35.9081 22.4595 34.911C22.2468 33.5218 22.0789 32.1438 21.9894 31.1131L21.9884 31.101C21.8994 30.0214 21.8442 29.3513 21.9334 28.5699C21.9782 28.1666 22.1237 27.8865 22.3811 27.6065C22.8848 27.0687 23.7691 26.7326 24.8101 26.7326C25.8511 26.7326 26.7353 27.0799 27.239 27.6065ZM16.9059 23.7298C16.9619 19.5397 20.3199 16.0779 24.5062 15.9211C29.0059 15.7418 32.7333 19.3605 32.7221 23.8194C32.7221 26.5306 31.3453 28.9393 29.2634 30.3621C29.1514 30.4405 29.0059 30.3509 29.0171 30.2277C29.0395 29.7459 29.0507 29.3202 29.0283 28.8833C29.0283 28.7376 29.0843 28.6032 29.185 28.5024C30.4275 27.326 31.211 25.6679 31.211 23.8306C31.211 20.2231 28.2112 17.2879 24.5622 17.4335C21.2042 17.568 18.5066 20.3016 18.417 23.6625C18.3722 25.5671 19.1558 27.2924 20.443 28.5024C20.5549 28.6032 20.6109 28.7376 20.5997 28.8833C20.5773 29.3314 20.5773 29.7571 20.6109 30.2389C20.6109 30.3621 20.4654 30.4405 20.3647 30.3733C18.2491 28.9281 16.8723 26.4858 16.9059 23.7298Z",
    fill: "url(#paint0_linear_223_12003)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_223_12003",
    x1: 24.8207,
    y1: 12,
    x2: 24.8207,
    y2: 37.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_12003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePodcast);
export default __webpack_public_path__ + "static/media/Apple Podcast.443b5d7838d2c8ef12128ce3931edcd4.svg";
export { ForwardRef as ReactComponent };